import { VFC } from 'react';

export const InstallationTechnologyStepFooter: VFC = () => {
  return null;
};
